import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthHelper } from '../helpers/auth.helper';
import { ToastService } from '../services/toastr.service';
import { UserRole } from '@/app/auth/enums/role.enum';

export const loginGuard: CanActivateFn = (route, state) => {
  const authHelper = inject(AuthHelper);

  if (authHelper.isUserLogged() && state.url.includes('students/join')) {
      return true;
  }

  
  if (authHelper.isUserLogged()) {
    inject(Router).navigateByUrl('/control-panel/patients');
    return false;
  }

  return true;
};
